// extracted by mini-css-extract-plugin
module.exports =  {"STORY_FLOW_OFFSET_TOP":"40px"};